export default {
  "content": "<path d=\"M0 0l5 5 5-5H0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 10 5"
  }
};